var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',_vm._b({scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_vm._t("default",function(){return [_c('v-icon',[_vm._v("mdi-information")])]})],2)]}}],null,true)},'v-tooltip',_vm.$attrs,false),[_vm._t("content",function(){return [_vm._v("Coming Soon!")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }